module.exports = __webpack_public_path__ + "static/colorofchange-730abdcb5a405d73f983d448027658c9.png";